import {
  InteractiveContainer,
  PlainButton,
  Tooltip,
  PageLoaderFull,
} from "@jugl-web/ui-kit";
import { onEscape, useTranslations } from "@jugl-web/utils";
import React, { useState } from "react";
import { entitiesApi } from "@web-src/modules/api/createApi";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { ReactComponent as CheckIcon } from "./assets/check.svg";

export const WorkspaceEditableName: React.FC = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { entity } = useEntitySelectedProvider();
  const [workspaceName, setWorkspaceName] = useState("");
  const [updateEntity, { isLoading }] = entitiesApi.useEditEntityMutation();

  const { t } = useTranslations();

  const handleEditWorkspaceName = () => {
    setIsEditing(true);
    setWorkspaceName(entity.name);
  };

  const handleNameChange = async () => {
    const response = await updateEntity({
      data: { name: workspaceName },
      entityId: entity.id,
      meta: {
        successMessage: t({
          id: "workspace-settings-page.workspace-name-was-updated",
          defaultMessage: "Workspace name was updated",
        }),
      },
    });
    if (response && "data" in response) {
      setIsEditing(false);
    }
  };

  return (
    <>
      <PageLoaderFull isActive={isLoading} isTransparent />
      {isEditing ? (
        <div className="relative flex items-start gap-4">
          <input
            className="w-[400px] border-0 border-b border-solid border-black/20 bg-transparent py-[14px] pt-2 pr-16 font-[Roboto] text-[26px] leading-[39px] font-medium text-dark transition-colors outline-none focus:border-primary"
            value={workspaceName}
            onChange={(event) => setWorkspaceName(event.target.value)}
            onKeyDown={onEscape(() => setIsEditing(false))}
            autoFocus
          />
          <PlainButton
            className="absolute top-2 right-2 flex h-10 w-10 items-center justify-center rounded-xl bg-primary"
            disabled={workspaceName.trim().length < 1}
            onClick={handleNameChange}
          >
            <CheckIcon />
          </PlainButton>
        </div>
      ) : (
        <Tooltip
          placement="right"
          delay="none"
          renderTrigger={({ ref }) => (
            <InteractiveContainer
              ref={ref}
              className="transition-color w-full rounded-[10px] px-1 py-2 duration-300 hover:bg-[#EEF2F5]"
              onClick={handleEditWorkspaceName}
            >
              <div className="text-[26px] font-medium break-words whitespace-pre-wrap text-dark">
                {entity.name}
              </div>
            </InteractiveContainer>
          )}
        >
          {t({
            id: "workspace-settings-page.tap-to-edit-workspace-name",
            defaultMessage: "Tap to edit workspace name",
          })}{" "}
          ✨
        </Tooltip>
      )}
    </>
  );
};
